import React from 'react';

export class FormControl {
    constructor() {
        this.handleChange = this.handleChange.bind(this);
        this.registerFormElement = this.registerFormElement.bind(this);
        this.isFormElementRegistered = this.isFormElementRegistered.bind(this);
        this.updateFormElement = this.updateFormElement.bind(this);

        this.valid = false;
        this.dirty = false;
        this.elements = {};
    }

    handleChange() {}
    registerFormElement() {}
    isFormElementRegistered() {}
    updateFormElement() {}
}

export const FormContext = React.createContext(new FormControl());